/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Battle_RoyaleInputs */

const en_map_battle_royale = /** @type {(inputs: Map_Battle_RoyaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Battle Royale`)
};

const fr_map_battle_royale = /** @type {(inputs: Map_Battle_RoyaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Battle Royale`)
};

const ms_sg2_map_battle_royale = /** @type {(inputs: Map_Battle_RoyaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Battle Royale`)
};

/**
* | output |
* | --- |
* | "Battle Royale" |
*
* @param {Map_Battle_RoyaleInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const map_battle_royale = /** @type {((inputs?: Map_Battle_RoyaleInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Battle_RoyaleInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_map_battle_royale(inputs)
	if (locale === "fr") return fr_map_battle_royale(inputs)
	return ms_sg2_map_battle_royale(inputs)
});